import { env } from "../../../../../../config/EnvironmentConfig";

export const defaultConfigApi = {
  spUserEmail: (() => {
    const authToken = window.localStorage.getItem("auth_token");
    if (authToken) {
      try {
        const parsed = JSON.parse(authToken);
        return parsed.email || "";
      } catch {
        return "";
      }
    }
    return "";
  })(),
  domain: env?.baseUrlMAT ?? "",
  xApiKey: "60F5B299-85B6-4EF9-9623-0C29A71DE0B3",
};